module.exports = __webpack_public_path__ + "static/media/ImageBG.5daaddbb.png";